import WedsiteSystemThemes from '@/lib/api/WedsiteSystemThemes'
import Themes from '@/lib/api/Themes'
import Images from '@/lib/api/Images'
import {
  getThemePreviewUrlParameters,
  getObjectWithoutCache,
  objectsIsEquals,
} from './storeThemeUtils'

const alertBrowserListener = function (event) {
  event.returnValue = 'Alterações realizadas!'
}

const initialState = () => ({
  theme: {},
  savedCustomizations: {},
  customizations: {},
  lastCustomization: '',
  showPreviewTheme: true,
})

const state = initialState()

const getters = {
  themeId: (state) => state.theme?.id,

  themeName: (state) => state.theme?.name,

  defaultCustomizations: (state) => state.theme?.options?.customizations,

  savedCustomizations: (state) => state.savedCustomizations,

  customizations: (state) => state.customizations,

  hasChangesCustomizations: (state) => {
    const hasChanges = !objectsIsEquals(
      state.savedCustomizations,
      state.customizations
    )
    if (hasChanges)
      window.addEventListener('beforeunload', alertBrowserListener, false)
    return hasChanges
  },

  lastCustomization: (state) => state.lastCustomization,

  showPreviewTheme: (state) => state.showPreviewTheme,

  previewThemeParams: (state) => {
    const { customizations, lastCustomization } = state
    return getThemePreviewUrlParameters(customizations, lastCustomization)
  },
}

const actions = {
  async fetchTheme({ commit, rootGetters }, theme_id) {
    const token = rootGetters['app/logonToken']
    const service = new WedsiteSystemThemes(token)
    const response = await service.getThemeOptions(theme_id)
    commit('SET_THEME', response.data)
  },

  async fetchInitialCustomizations({ commit, getters, rootGetters }) {
    const token = rootGetters['app/logonToken']
    const service = new Themes(token)
    const response = await service.getThemeCustomizations(getters.themeId)
    commit('SET_SAVED_CUSTOMIZATIONS', response?.data?.data?.settings)
    commit('SET_CUSTOMIZATIONS', response?.data?.data?.settings)
  },

  async saveCustomizations({ commit, getters, rootGetters }) {
    const token = rootGetters['app/logonToken']
    const service = new Themes(token)
    try {
      const response = await service.updateThemeCustomizations({
        theme_id: getters.themeId,
        ...getters.customizations,
      }) // the correct thing is to analyze the server's response
      commit('SET_SAVED_CUSTOMIZATIONS', getters.customizations)
      window.removeEventListener('beforeunload', alertBrowserListener, false)
      return response
    } catch (e) {
      return { error: e }
    }
  },

  async uploadImageUser({ rootGetters }, data) {
    const token = rootGetters['app/logonToken']
    const formData = new FormData()
    formData.append('file', data.file)
    const service = new Images(token)
    const response = await service.upload(formData)
    if (response.error) return response
    const userCustomizations = {}
    userCustomizations[data.code] = 0
    userCustomizations[`${data.code}_user`] = response.data.data?.name
    userCustomizations[`${data.code}_user_copied`] = 0
    return userCustomizations
  },

  setNewCustomizationOption({ commit, getters }, customizationOption) {
    const changes = {
      ...getters.customizations,
      ...customizationOption,
    }
    commit('SET_CUSTOMIZATIONS', changes)
    for (const keyname in customizationOption) {
      commit('SET_LAST_CUSTOMIZATION', keyname)
    }
  },

  discardCustomizationsWithoutSaving({ commit, getters }) {
    window.removeEventListener('beforeunload', alertBrowserListener, false)
    commit('SET_CUSTOMIZATIONS', getters.savedCustomizations)
  },

  togglePreviewMode({ commit, getters }) {
    commit('SET_SHOW_PREVIEW_THEME', !getters.showPreviewTheme)
  },
}

const mutations = {
  SET_THEME(state, payload) {
    state.theme = payload
  },

  SET_SAVED_CUSTOMIZATIONS(state, payload) {
    state.savedCustomizations = getObjectWithoutCache(payload)
  },

  SET_CUSTOMIZATIONS(state, payload) {
    state.customizations = getObjectWithoutCache(payload)
  },

  SET_LAST_CUSTOMIZATION(state, payload) {
    state.lastCustomization = payload
  },

  SET_SHOW_PREVIEW_THEME(state, payload) {
    state.showPreviewTheme = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
